import React from 'react'
import { selectNavHeight } from "../../../../redux/navbar/navHeightSlice";
import { useSelector } from "react-redux";
import InspectionEmailer from './InspectionEmailNotification'

const InspectionEmailerNotification = () => {
    const navHeight = useSelector(selectNavHeight);
  
  return (
  <div  className="mx-auto w-full"
    style={{
      marginTop: navHeight,
      height: `calc(100vh - ${navHeight}px)`,
      overflow: "auto",
    }} >
      <InspectionEmailer />
    </div>
  );
}

export default InspectionEmailerNotification